var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDiamondLight = function SvgIconDiamondLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.095 11.418a1 1 0 0 1 .855-.482h7.43a1 1 0 0 1 .95 1.314l-2.12 6.41a1 1 0 0 1-.95.686H9.07a1 1 0 0 1-.855-1.518l3.88-6.41Zm1.419 1.518-2.67 4.41h6.694l1.458-4.41h-5.482ZM26.81 11.35a1 1 0 0 1 .81-.415h7.43a1 1 0 0 1 .856.483l3.88 6.41a1 1 0 0 1-.856 1.518h-9.2a1 1 0 0 1-.95-.688l-2.11-6.41a1 1 0 0 1 .14-.899Zm2.192 1.585 1.452 4.41h6.702l-2.67-4.41h-5.484Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.175 17.9a1 1 0 0 1 .895-.554h9.19a1 1 0 0 1 .96.72l5.74 19.72a1 1 0 0 1-1.757.883L8.273 18.95a1 1 0 0 1-.098-1.049Zm2.907 1.446 10.443 13.793-4.015-13.793h-6.428Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.77 18.067a1 1 0 0 1 .96-.721h9.2a1 1 0 0 1 .798 1.603l-14.93 19.72a1 1 0 0 1-1.758-.883l5.73-19.72Zm1.711 1.279-4.01 13.799 10.448-13.8h-6.438Z",
    fill: "#121619"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.43 11.621a1 1 0 0 1 .95-.686h7.24a1 1 0 0 1 .95.688l2.11 6.41a1 1 0 0 1-.95 1.313H18.26a1 1 0 0 1-.95-1.314l2.12-6.41Zm1.673 1.314-1.459 4.41h8.704l-1.451-4.41h-5.794Z",
    fill: "#121619"
  })));
};
export default SvgIconDiamondLight;